import { render } from "./MarkdownPanel.vue?vue&type=template&id=4acd3632&scoped=true"
import script from "./MarkdownPanel.vue?vue&type=script&lang=js"
export * from "./MarkdownPanel.vue?vue&type=script&lang=js"

import "./MarkdownPanel.vue?vue&type=style&index=0&id=4acd3632&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd3632"]])

export default __exports__